import { render, staticRenderFns } from "./AddOrEditNewsCategory.vue?vue&type=template&id=b2acc868"
import script from "./AddOrEditNewsCategory.vue?vue&type=script&lang=js"
export * from "./AddOrEditNewsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports